// src/components/AuthForm.jsx
import React, { useState } from 'react';
import { FaFacebookF, FaMicrosoft, FaGoogle } from 'react-icons/fa';
import styles from './AuthForm.module.css';

export default function AuthForm({
  title,
  image,
  fields,
  onSubmit,
  onSuccess,
  onFailure,
  submitLabel,
  submittingLabel,
  errorMessage,
  successMessage,
  errorClassName = styles.formError,
  successClassName = styles.formSuccess,
  footerLinks = [],
  showSocialIcons = true,
}) {
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);

    try {
      const result = await onSubmit();
      if (onSuccess) onSuccess(result);
    } catch (error) {
      if (onFailure) onFailure(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={styles.authPage}>
      <img src={image} alt="" className={styles.authImage} />
      <h2 className={styles.authTitle}>{title}</h2>

      <form className={styles.authForm} onSubmit={handleSubmit}>
        {fields.map((field) => (
          <label key={field.name}>
            {field.label}
            {field.customElement ? (
              field.customElement
            ) : (
              <input
                type={field.type}
                value={field.value}
                onChange={field.onChange}
                required
              />
            )}
          </label>
        ))}

        {errorMessage && (
          <div className={errorClassName}>{errorMessage}</div>
        )}

        {successMessage && (
          <div className={successClassName}>{successMessage}</div>
        )}

        <button
          type="submit"
          className={styles.authButton}
          disabled={loading}
        >
          {loading ? submittingLabel || `${submitLabel}...` : submitLabel}
        </button>
      </form>

      {showSocialIcons && (
        <div className={styles.authIcons}>
          <button className={`${styles.iconButton} ${styles.facebook}`} aria-label="Facebook login">
            <FaFacebookF size={20} />
          </button>
          <button className={`${styles.iconButton} ${styles.google}`} aria-label="Google login">
            <FaGoogle size={20} />
          </button>
          <button className={`${styles.iconButton} ${styles.microsoft}`} aria-label="Microsoft login">
            <FaMicrosoft size={20} />
          </button>
        </div>
      )}

      <div className={styles.authLinks}>
        {footerLinks.map(({ href, label }) => (
          <a key={href} href={href} className={styles.authLink}>
            {label}
          </a>
        ))}
      </div>
    </div>
  );
}
